export default "__VITE_ASSET__zey3TXxC__"